import ProjectView from "../../project-view"
import openFormAction from "../../../../../app/tools/request-forms2/actions/open-form"
import editFormAction from "../../../../../app/tools/request-forms2/actions/edit-form"
import ProjectViews from "../../project-views"
import {ProjectView_Form_AccessControl} from "./acl"
import {ProjectViewConfig} from "../../@types";

const debug = false
// const debug = "ProjectView_Form"

export default class ProjectView_Form extends ProjectView {

    constructor(viewConfig:ProjectViewConfig, projectViews:ProjectViews) {
        super(viewConfig, projectViews)

        this.name       = _.get(viewConfig, 'name', 'Form')
    }

    get acl():ProjectView_Form_AccessControl {

        if (!this._acl) {
            this._acl = new ProjectView_Form_AccessControl(this)
        }

        return this._acl
    }

    open(options?: {
        isAutoOpen?: boolean
    }) {
        debug && console.log(debug, 'open', options)
        if (!options?.isAutoOpen) {
            const form = _.find(this.projectViews.project.properties.forms, form => form.id === this.id)
            debug && console.log(debug, 'open form', form)
            if (form) openFormAction(form)
        }
    }

    edit() {
        editFormAction(this.id)
    }

    copyUrl() {
        const form = _.find(this.projectViews.project.properties.forms, form => form.id === this.id)
        if (!form) return

        const url = gdConfig.sharedViewPath + form.publicKey
        gd.utils.copyToClipboard(url)
        gd.growl.success('URL copied to clipboard.')
    }
}